// extracted by mini-css-extract-plugin
module.exports = {"Login":"pp_a"};